type PropsT = {
  className?: string
  strokeColor?: string
}

// Outline check-in-circle glyph. Path mirrors the restrict-customer modal's "What this means" rows
// (Sketch order-feedback-landing-page v83 `.rst-row svg`).
const CheckCircleOutline = (props: PropsT) => {
  const { className, strokeColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="check-circle-outline-icon"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  )
}

export default CheckCircleOutline
